// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAttachmentData } from './genericApiResponseAttachmentData';
import type { GenericApiResponseAttachmentMessage } from './genericApiResponseAttachmentMessage';
import type { GenericApiResponseAttachmentPagination } from './genericApiResponseAttachmentPagination';
import type { GenericApiResponseAttachmentError } from './genericApiResponseAttachmentError';

export interface GenericApiResponseAttachment {
  data?: GenericApiResponseAttachmentData;
  message?: GenericApiResponseAttachmentMessage;
  pagination?: GenericApiResponseAttachmentPagination;
  error?: GenericApiResponseAttachmentError;
  statusCode?: number;
}
